export default {
  ROLE: {
    EDITOR: 'editor',
    VIEWER: 'viewer',
  },
  MAX_ONLINE_HEADS_DISPLAY: 3,
  MAX_ALLOWED_COLLABORATORS: 100,
}
